module.exports = __webpack_public_path__ + "img/ed.76e0501c.svg";